import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'mwp-agent-sass-buttons',
    templateUrl: './sass-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SassButtonsComponent {
    constructor(){
    }

    
}